<template>
    <div  v-if="showInstall&&deferredPrompt" class="min-w-[v-90] px-4 m-2 self-center md:w-1/3 fixed bottom-2 gap-2 bg-white drop-shadow rounded-sm p-2 z-[99999] flex flex-col items-center">
        <div class="flex items-center gap-2">
            <img src="@/assets/Mosaic-Logo.svg" class="w-12">
            <p>Instal·la el Mosaic com una app!</p>
           
            
        </div>
         <div class="flex items-center gap-2 justify-center">
             <button @click="install" class="bg-red-600 rounded-sm text-white px-3 py-2 font-bold hover:bg-red-500">Instal·la</button>
             <button @click="showInstall=false" class="bg-gray-200 rounded-sm white px-3 py-2 hover:bg-gray-300 flex items-center gap-2"><p>No, gràcies</p> </button>
         </div>    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import { useGtag } from  'vue-gtag-next'

const { event } = useGtag()
const deferredPrompt = ref(null)
const showInstall = ref(true)

onMounted(() => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e
    showInstall.value = true
  })
})

const install = async () => {
  if (deferredPrompt.value) {
    event('instal_la', {
                    category: 'Instal·la',
                    label: 'Insatal·lat',
                    value: 1
                }
                )
    deferredPrompt.value.prompt()
    await deferredPrompt.value.userChoice
    deferredPrompt.value = null
    showInstall.value = false
  }
}

window.addEventListener('appinstalled', () => {
  showInstall.value = false
  deferredPrompt.value = null
})

</script>